import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { autoSignIn, removeDeferredLoadingFlags } from "../../../store/actions";
import { useStore } from "../../../store/useStore";
import { DeferredLoadingFlags } from "../../../util";
import { LoadingPage } from "../../LoadingPage";
import decode from "jwt-decode";
import logger from "../../../config/Logging";

type JWTPayload = {
  email: string;
};

const AuthPage: React.FC = () => {
  const history = useHistory();
  const { state, dispatch } = useStore();

  useEffect(() => {
    /**
     * Wait for silent auth to finish first, if this is successful
     * then this entire block will be skipped (user already authenticated)
     */
    if (state.loading.has(DeferredLoadingFlags.SILENT_AUTH)) return;
    const params = new URLSearchParams(history.location.search);
    const jwt = params.get("jwt");
    const redirectUrl = params.get("redirect");

    // If user is already in the state, take them were they were going to go
    if (state.user) return history.replace(redirectUrl || "/");

    const tokenAuth = async (email: string, jwt: string) => {
      try {
        await dispatch(autoSignIn(email, jwt));
        history.replace(redirectUrl || "/");
      } catch (error) {
        history.replace("/login", { redirectUrl });
      }
      dispatch(removeDeferredLoadingFlags(DeferredLoadingFlags.SILENT_AUTH));
    };

    if (jwt) {
      try {
        logger.log("info", "Decoding jwt", {
          additionalInfo: {
            tags: "session",
            file: "pages.Public.AuthPage",
          },
        });
        const decoded = decode<JWTPayload>(jwt);
        logger.log("info", "Decoding jwt success", {
          additionalInfo: {
            tags: "session",
            file: "pages.Public.AuthPage",
          },
        });
        tokenAuth(decoded.email, jwt);
      } catch (error) {
        console.log(error);
        logger.log("error", "Decoding jwt failed", {
          additionalInfo: {
            tags: "session",
            file: "pages.Public.AuthPage",
          },
        });
        // Problem decoding JWT
        history.replace("/login", { redirectUrl });
      }
    } else {
      history.replace("/login", { redirectUrl });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.loading.has(DeferredLoadingFlags.SILENT_AUTH)]);

  return <LoadingPage tip="Authenticating" />;
};

export default AuthPage;
